function getEnv(url: string) {
  switch (true) {
    case url.includes('xilo.io'):
      return 'production';
    case url.includes('herokuapp.com'):
      return 'staging';
    case url.includes('localhost'):
      return 'development';
    default:
      return 'production';
  }
}

export function getClientSubmissionPath(userRole: 'agent' | 'admin', submissionId: number, url: string) {
  const env = getEnv(url);
  const userRolePath = userRole === 'agent' ? 'agent' : 'profile';
  switch (env) {
    case 'production':
      return `https://dashboard.xilo.io/${userRolePath}/submission/${submissionId}`;
    case 'staging':
      return `https://xilo-dev-dashboard.herokuapp.com/${userRolePath}/submission/${submissionId}`;
    case 'development':
      return `http://localhost:4100/${userRolePath}/submission/${submissionId}`;
  }
}
